import { sensorConstants } from "../_constants";

export const sensorOn = message => ({
  type: sensorConstants.SENSOR_ON,
  message
});

export const sensorOff = message => ({
  type: sensorConstants.SENSOR_OFF,
  message
});

export const sensorList = list => ({
  type: sensorConstants.SENSOR_LIST,
  list
});

export const sensorId = id => ({
  type: sensorConstants.SENSOR_ID,
  id
});

export const getSensorData = list => ({
  type: sensorConstants.SENSOR_DATA,
  list
});

export const filteredSensorDataList = list => ({
  type: sensorConstants.SENSOR_FILTER,
  list
});



// WEBPACK FOOTER //
// ./src/_actions/sensor.actions.js